import React from 'react';
import { useTranslation } from 'react-i18next';
import { OrderingOperations } from 'polygon-ordering';
import StandardButton from './StandardButton';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import { logEvent } from '../utils/analytics';
import EVENTS from '../constants/events';
import { setOrderDate } from '../slices/orderDate';
import getDeviceTypeMobile from '../selectors/getDeviceTypeMobile';
import combineStyles from '../utils/combineStyles';
import getThemeLookup from '../selectors/getThemeLookup';
import { setReorderableItems } from '../slices/reorderableItems';
import { updateForm } from '../slices/deliveryAddressForm';
import { clearBuffer, setDeliveryTimePrevious } from '../libs/polygon-ordering/src/operations';
import { setDesiredDeliveryTime } from '../slices/desiredDeliveryTime';
import { ASAP_TIME } from '../libs/polygon-ordering/src/constants';

const { startNewOrder } = OrderingOperations;

const NewOrderButton = () => {
  const { t } = useTranslation();
  const p = useAppSelector(getThemeLookup);
  const dispatch = useAppDispatch();
  const deviceTypeMobile = useAppSelector(getDeviceTypeMobile);
  const desiredDeliveryTime = useAppSelector(state => state.desiredDeliveryTime);

  return (
    <div
      style={combineStyles(
        styles.bottomBar,
        deviceTypeMobile && {
          padding: 30,
          background: 'transparent',
        },
        p('reviewOrderBottomBar', ['backgroundColor']),
      )}
    >
      <StandardButton
        label={t('button.startNewOrder')}
        themeKey="newOrderButton"
        onClick={async () => {
          await dispatch(
            startNewOrder({
              preserveMember: true,
            }),
          );
          dispatch(updateForm({ showTimePicker: false }));
          dispatch(clearBuffer({}));
          dispatch(setDeliveryTimePrevious(desiredDeliveryTime));
          dispatch(setDesiredDeliveryTime(ASAP_TIME));
          dispatch(setReorderableItems(null));
          dispatch(setOrderDate(null));
          logEvent(EVENTS.START_NEW_ORDER);
        }}
        containerStyle={styles.buttonContainer}
      />
    </div>
  );
};

export default NewOrderButton;

const styles: Styles = {
  buttonContainer: {
    borderRadius: 5,
    width: '100%',
    maxWidth: 400,
    padding: '0.925em 1.25em',
  },
  bottomBar: {
    position: 'sticky',
    bottom: 0,
    width: '100%',
    backgroundColor: '#fff',
    display: 'flex',
    zIndex: 99,
    justifyContent: 'center',
    padding: '0.75em',
  },
};
